export const generateUuid = () => {
    // NOTE: based on https://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid
    const result = '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) => (+c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))).toString(16));
    return result;
};
//# sourceMappingURL=generate-uuid.js.map